


const EnvoieReducer = (state, action) => {
    switch (action.type) {
        case "GET_ENVOIS_START":
            return {
                ...state,
                envois: [],
                envoisPickupArrived: [],
                isFetching: true,
                error: false,
            };
        case "GET_ENVOIS_SUCCESS":
            return {
                ...state,
                envois: action.payload.envois,
                envoisPickupArrived: action.payload.envoisPickupArrived,
                count: action.payload.count,
                isFetching: false,
                error: false,
            };
        case "GET_ENVOIS_FAILURE":
            return {
                ...state,
                envois: [],
                envoisPickupArrived: [],
                isFetching: false,
                error: action.payload,
            };
        case "GET_ENVOIE_START":
            return {
                ...state,
                envoie: {},
                isFetchingGet: true,
                errorGet: false,
            };
        case "GET_ENVOIE_SUCCESS":
            return {
                ...state,
                envoie: action.payload.envoie,
                isFetchingGet: false,
                errorGet: false,
            };
        case "GET_ENVOIE_FAILURE":
            return {
                ...state,
                envoie: {},
                isFetchingGet: false,
                errorGet: action.payload,
            };
        case "ADD_ENVOIE_START":
            return {
                ...state,
                envoie: {},
                isFetchingAdd: true,
                errorAdd: false,
            };
        case "ADD_ENVOIE_SUCCESS":
            return {
                ...state,
                envoie: action.payload.envoie,
                isFetchingAdd: false,
                errorAdd: false,
            };
        case "ADD_ENVOIE_FAILURE":
            return {
                ...state,
                envoie: {},
                isFetchingAdd: false,
                errorAdd: action.payload,
            };
        case "UPDATE_ENVOIE_START":
            return {
                ...state,
                envoieUpdate: {},
                isFetchingUpdate: true,
                errorUpdate: false,
            };
        case "UPDATE_ENVOIE_SUCCESS":
            return {
                ...state,
                envoieUpdate: action.payload.envoie,
                isFetchingUpdate: false,
                errorUpdate: false,
            };
        case "UPDATE_ENVOIE_FAILURE":
            return {
                ...state,
                envoieUpdate: {},
                isFetchingUpdate: false,
                errorUpdate: action.payload,
            };
        case "RESTART_ENVOIE":
            return{
                ...state,
                envoie: {},
                envoieUpdate: {},
            };
        case "GET_COSTS_START":
            return {
                ...state,
                costs: [],
                costsentreprise: [],
                isFetchingCosts: true,
                errorCosts: false,
            };
        case "GET_COSTS_SUCCESS":
            return {
                ...state,
                costs: action.payload.costs,
                costsentreprise: action.payload.costsentreprise,
                isFetchingCosts: false,
                errorCosts: false,
            };
        case "GET_COSTS_FAILURE":
            return {
                ...state,
                costs: [],
                costsentreprise: [],
                isFetchingCosts: false,
                errorCosts: action.payload,
            };
        case "SIMULATE_COST_START":
            return {
                ...state,
                cost: "",
                isFetchingSimulate: true,
                errorSimulate: false,
            };
        case "SIMULATE_COST_SUCCESS":
            return {
                ...state,
                cost: action.payload.cost,
                isFetchingSimulate: false,
                errorSimulate: false,
            };
        case "SIMULATE_COST_FAILURE":
            return {
                ...state,
                cost: "",
                isFetchingSimulate: false,
                errorSimulate: action.payload,
            };
        case "UPDATE_COSTS_START":
            return {
                ...state,
                mess: '',
                isFetchingCostsUpdate: true,
                errorCostsUpdate: false,
            };
        case "UPDATE_COSTS_SUCCESS":
            return {
                ...state,
                mess: action.payload.message,
                isFetchingCostsUpdate: false,
                errorCostsUpdate: false,
            };
        case "UPDATE_COSTS_FAILURE":
            return {
                ...state,
                mes: '',
                isFetchingCostsUpdate: false,
                errorCostsUpdate: action.payload,
            };
        case "GET_HISTORIES_ENVOIE_START":
            return {
                ...state,
                histories: [],
                isFetchingHistories: true,
                errorHistories: false,
            };
        case "GET_HISTORIES_ENVOIE_SUCCESS":
            return {
                ...state,
                histories: action.payload.histories,
                isFetchingHistories: false,
                errorHistories: false,
            };
        case "GET_HISTORIES_ENVOIE_FAILURE":
            return {
                ...state,
                histories: [],
                isFetchingHistories: false,
                errorHistories: action.payload,
            };
        default:
            return { ...state };
    }
}

export default EnvoieReducer;